// extracted by mini-css-extract-plugin
export var label = "_dz-5";
export var slideContainer = "_dz-0";
export var slider = "_dz-1";
export var sliderLg = "_dz-4";
export var sliderMd = "_dz-3";
export var sliderSm = "_dz-2";